import { render, staticRenderFns } from "./AreaChartVT.vue?vue&type=template&id=a5628312&scoped=true"
import script from "./AreaChartVT.vue?vue&type=script&lang=js"
export * from "./AreaChartVT.vue?vue&type=script&lang=js"
import style0 from "./AreaChartVT.vue?vue&type=style&index=0&id=a5628312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5628312",
  null
  
)

export default component.exports